<template>

    <div class="row m-1 mt-2">

        <div class="col-2">
            <div class="card">
                <div class="card-body">
                    <ul>
                        <li><a @click.prevent="showTabs('baseinformation')" href="#">Informazioni base</a></li>
                        <li><a @click.prevent="showTabs('offices')"  href="#">Uffici</a></li>
                        <li><a @click.prevent="showTabs('notes')"  href="#">Note</a></li>
                    </ul>
                </div>

            </div>
        </div>
        <div class="col-10 tabs">
            <div class="card " id="baseinformation">
                <div class="card-body"> 

                    <div class="row">
                        <div class="col-12">
                            <h3>Informazioni di base</h3>
                            <div class="form-group">
                                <ValidationProvider v-slot="{ classes, errors }" immediate slim rules="required">
                                    <label class="col-form-label" for="internalCode">Codice interno</label>
                                    <input type="text" class="form-control required" id="internalCode" name="internalCode" placeholder="Codice interno" v-model="entity.internalCode" :class="classes">
                                </ValidationProvider>
                            </div>
                        </div>
                        <!--<form @submit.prevent="save" v-if="entity">-->
                        <div class="col-12">
                            <div class="form-group">
                                <ValidationProvider v-slot="{ classes, errors }" immediate slim rules="required">
                                    <label class="col-form-label" for="name">Ragione sociale</label>
                                    <input type="text" class="form-control required" id="name" name="name" placeholder="Ragione sociale" v-model="entity.name" :class="classes">
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-form-label" for="fiscalCode">Codice Fiscale</label>
                                <input type="text" class="form-control" id="fiscalCode" name="fiscalCode" placeholder="Codice Fiscale" maxlength="16" v-model="entity.fiscalCode">
                            </div>

                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-form-label" for="vatNumber">Partita IVA</label>
                                <input type="text" class="form-control" id="vatNumber" name="vatNumber" placeholder="Partita IVA" maxlength="11" v-model="entity.vatNumber">
                            </div>

                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-form-label" for="rea">R.E.A</label>
                                <input type="text" class="form-control" id="rea" name="rea" placeholder="R.E.A" maxlength="200" v-model="entity.rea">
                            </div>

                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-form-label" for="sdi">SDI</label>
                                <input type="text" class="form-control" id="sdi" name="sdi" placeholder="R.E.A" maxlength="200" v-model="entity.sdi">
                            </div>

                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <email-address-list v-model="entity.emails"></email-address-list>
                    </div>
                    <div class="row">
                        <phonelist v-model="entity.phones"></phonelist>
                    </div>
                    <div class="row">
                        <websitelist v-model="entity.webSites"></websitelist>
                    </div>
                    <div class="row">
                        <faxlist v-model="entity.faxes"></faxlist>
                    </div>


                    <div class="row">

                        <div class="col-12">
                            <div class="form-group">
                                <label class="col-form-label" for="address">Indirizzo</label>
                                <input type="text" class="form-control" id="address" placeholder="Indirizzo" v-model="entity.address">

                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label class="col-form-label" for="city">Citt�</label>
                                <input type="text" class="form-control" name="city" id="city" placeholder="Citt�" v-model="entity.city">

                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label class="col-form-label" for="zipCode">CAP</label>
                                <input type="text" class="form-control" name="zipCode" id="zipCode" placeholder="CAP" v-model="entity.zipCode">

                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label class="col-form-label" for="district">Provincia</label>
                                <input type="text" class="form-control" name="district" id="district" placeholder="provincia" v-model="entity.district">

                            </div>
                        </div>
                        <div class="col-12">

                            <gmap :value="entity" :addressProperties="['address','city','zipCode','district']"></gmap>

                        </div>
                    </div>



                    <div class="row mt-2">
                        <div class="col-12">
                            <h4>Elenco Tags associati</h4>
                        </div>
                        <div class="col-12">
                            <taglist v-model="entity.tags"></taglist>
                        </div>
                    </div>



                    <div class="row">

                        <div class="form-group mt-3">
                            <button type="button" class="btn btn-xs  btn-primary m-1" v-on:click="save">Salva  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>
                            <button type="button" class="btn btn-xs  btn-danger m-1" v-on:click="cancel">Annulla  <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>
                        </div>
                        <!--</form>-->

                    </div>


                </div>
            </div>
            <div class="card d-none" id="offices">
                  <div class="card-body">

                    <div class="row">
                        <div class="col-12">
<h3>Elenco uffici</h3>
 <router-link class="btn btn-sm btn-primary" :to="{name:'route-office-edit', params:{'id':'00000000-0000-0000-0000-000000000000', 'pid': $route.params.id }}">
                                <font-awesome-icon icon="plus-circle"></font-awesome-icon> Aggiungi nuova azienda
                            </router-link>
                            <hr />
                            <table ref="table" id="list-company-table" class="table table-hover w-100"></table>
                        </div>
                    </div>
                  </div>
            </div>
            <div class="card d-none" id="notes">

            </div>
        </div>



        </div>


</template>

<script>
    import Editor from '@tinymce/tinymce-vue'
    import axios from 'axios'
    import { Chrome } from 'vue-color';
    import { Slider } from 'vue-color';
    export default {
        data() {
            return {
                entity: null,

            };
        },
        computed: {
            tagTypes: function () {
                return this.$store.state.tagTypes;
            },
            tinyKey: function () {
                return window.SETTINGS.TinyApiKey;
            }
        },
        components: {
            Editor,
            'chrome-picker': Chrome
        },
        name: 'OfficeSave',
        beforeMount() {
            var me = this;


            axios.get("office/" +( me.$route.params.id || '00000000-0000-0000-0000-000000000000') +'/'+ me.$route.params.pid).then(response => {
                console.log(response);
                me.entity = response.data;
            })



        },
        methods: {
            showTabs(tab) {
                $('.tabs .card').addClass('d-none');
                $('#'+tab).removeClass('d-none');
            },
            cancel() {
                this.$router.push({
                    name: "route-company-list",

                    replace: true
                });
            },

            updateFromPicker(color) {
                this.entity.backgroundColor = color.hex;
            },
            save() {
                let me = this;
                axios.post("office", this.entity).then(response => {
                    if (me.$route.params.pid != response.data.companyId) { me.$router.push({ name: 'route-company-edit', params: { id: response.data.companyId } }); }
                    if (me.$route.params.id != response.data.officeId) { me.$router.push({ name: 'route-office-edit', params: { id: response.data.officeId, pid: response.data.companyId } }); }

                    me.$swal(
                        {
                            title: "Salvataggio avvenuto correttamente",
                            text: "",
                            type: "success",
                            showCancelButton: false,
                            toast: true,
                            timer: 2000,
                            showConfirmButton: false,
                            position: "bottom-top"
                        });
                })
            }
        }
    };
</script>
